import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-dialog-confirm',
    templateUrl: './dialog-confirm.component.html',
    standalone: false
})
export class DialogConfirmComponent {

  title: string = '';
  body: string = '';

  constructor(public dialogRef: MatDialogRef<DialogConfirmComponent>,
              @Inject(MAT_DIALOG_DATA) data) {
    this.title = data.title;
    this.body = data.body ?? '';
  }

}
